import PropTypes from 'prop-types';

// anchor tag target attribute options
export var TARGET = {
  self: '_self',
  // opens in same window
  blank: '_blank',
  // opens new window
  parent: '_parent',
  // open in parent context window
  top: '_top' // open in top most context window
};

export var TARGET_TYPES = [TARGET.self, TARGET.blank, TARGET.parent, TARGET.top];
export var DEFAULT_TARGET = TARGET.self;
export var targetPropType = PropTypes.oneOf(TARGET_TYPES);